import createReducer from 'common/redux/utils/createReducer';
import {
  REQUEST_MEMO,
  RECEIVE_MEMO,
  MEMO_RECEIVE_FAILED,
  SAVING_MEMO,
  MEMO_SAVE_FAILED,
} from 'memo/actions/memo';

const initialState = {
  isFetching: false,
  didInvalidate: false,
};

const memo = createReducer(initialState, {
  [REQUEST_MEMO](state, action) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [RECEIVE_MEMO](state, { memo }) {
    return {
      ...state,
      isFetching: false,
      memo,
    };
  },
  [MEMO_RECEIVE_FAILED](state, { error }) {
    return {
      ...state,
      isFetching: false,
      receiveError: error,
    };
  },
  [SAVING_MEMO](state, { memo }) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [MEMO_SAVE_FAILED](state, { error }) {
    return {
      ...state,
      isFetching: false,
      saveError: error,
    };
  },
});

export default memo;



// WEBPACK FOOTER //
// ./src/modules/memo/reducers/memo.js